// Generated by CoffeeScript 2.7.0
var Sidenav;

export default Sidenav = Vue.extend({
  props: {
    navList: {
      type: Array
    },
    currentGroup: {
      type: Object
    },
    currentFolder: {
      type: Object
    },
    filter: {
      type: Object
    },
    view: {
      type: String
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  template: `<div class="sidenav-groups" :class="{'broad': editable}">
  <div class="group" v-for="(listItem, index) in navList">
    <div class="sub-nav">
      <div class="nav-group">
        <input v-if="view == 'show'" class="group-expand-judge" hidden="true" :id="'list_item_' + _folder_id(listItem)" type="checkbox" checked='true'>
        <input v-else class="group-expand-judge" hidden="true" :id="'list_item_' + _folder_id(listItem)" type="checkbox" v-model="listItem.expanded">
        <label class="nav-group-info" :for="'list_item_' + _folder_id(listItem)" @click="selectGroup(listItem)" :class="_extendClass(listItem)">
          <slot :item="listItem" name="label_template"></slot>
        </label>
        <div class="nav-group-details">
          <div class="sub-nav">
            <div class="nav-group"
                 v-for='nav in listItem.navs'
                 :key='nav.id'
                 v-if="judgeByFilter(nav)">
              <template v-if="nav.children">
                <input v-if="view == 'show'"
                       class="group-expand-judge"
                       hidden="true"
                       :id="_folder_id(listItem, nav)"
                       type="checkbox" />
                <input v-else
                       class="group-expand-judge"
                       hidden="true"
                       :id="_folder_id(listItem, nav)"
                       type="checkbox"
                       v-model="nav.expanded" />
              </template>
              <label class="nav-group-info justify-between"
                     :class="_extendClass(nav)"
                     :for="_folder_id(listItem, nav)"
                     @click='selectGroup(nav)'>
                <slot :item="nav" name="label_template">
                </slot>
              </label>
              <div class="nav-group-details" v-if='nav.children'>
                <div class="nav-item"
                     v-for='item in nav.children'
                     :key='item.id'
                     v-if="item != filter"
                     :class="_extendClass(item)"
                     @click='selectGroup(item)'>
                  <slot :item="item" name="label_template">
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  methods: {
    _folder_id: function(item = {}, nav = {}) {
      return `${item.type}_nav_${nav.id || ''}_${this.view || ''}`;
    },
    selectGroup: function(group) {
      return this.$emit('selectGroup', group);
    },
    _extendClass: function(item) {
      if (item.hasOwnProperty('navs') || item.hasOwnProperty('children')) {
        return {
          'active': this.currentFolder === item && this.view === 'Folder',
          'disabled': this.filter
        };
      } else {
        if (this.currentGroup === item && this.view === 'Group') {
          return 'active';
        }
      }
    },
    judgeByFilter: function(group) {
      if (this.filter) {
        return Boolean(group !== this.filter && group.id);
      } else {
        return true;
      }
    }
  }
});
